import React from 'react'
import Portal from '../../../../component/portal'
import { getImgUrl, i18n, throttle } from '../../../../common/util'
import { getGamesPage } from './service'

class GameList extends React.Component {
    constructor() {
        super(...arguments)
        this.state = {
            list: window._inject_app_data_.entities,
            hasMore: window._inject_app_data_.count > 8,
            page: 1
        }
        this.loadFlag = false
    }

    componentDidMount() {
        this.state.hasMore && window.addEventListener('scroll', this.scrollListener)
    }

    scrollListener = throttle(() => {
        const { top } = document.getElementById('game-list-more-anchor').getBoundingClientRect()
        const { clientHeight } = document.documentElement
        if (top + 100 <= clientHeight) {
            this.loadMore()
        }
    })

    loadMore = () => {
        if (this.loadFlag) {
            return
        }
        this.loadFlag = true
        const page = this.state.page + 1
        getGamesPage(page).then(data => {
            const { count, entities } = data
            const hasMore = count > page * 8
            this.setState({
                page,
                hasMore,
                list: [].concat(this.state.list, entities)
            })
            !hasMore && window.removeEventListener('scroll', this.scrollListener)
        }).finally(() => {
            this.loadFlag = false
        })
    }

    render() {
        return <div>
            <ul className="game-list-ul">
                {
                    this.state.list.map(item => (<a target="_self" href={`/game/${item.gameId}`}>
                        <li className="game-list-item">
                            <img alt="" className="game-item-img" src={getImgUrl(item.listThumbnail)}></img>
                            <div className="game-item-info">
                                <p className="game-item-name">{item.gameName}</p>
                                <p className="game-item-intro">{item.gameIntro}</p>
                            </div>
                        </li>
                    </a>))
                }
            </ul>
            {
                this.state.hasMore && <div className="game-list-btn-line" id="game-list-more-anchor">
                    <button className="game-list-btn" onClick={this.loadMore}>{i18n('_more')}+</button>
                </div>
            }
        </div>
    }
}

export default Portal(GameList, 'game-list-container')